import { render, staticRenderFns } from "./SocialWorkers.vue?vue&type=template&id=3e8528ba&scoped=true"
import script from "./SocialWorkers.vue?vue&type=script&lang=js"
export * from "./SocialWorkers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8528ba",
  null
  
)

export default component.exports